module.exports = {"btnCreateComplaintText":"Utwórz zgłoszenie","btnPreviewComplaintText":"Podgląd zgłoszenia"}


//////////////////
// WEBPACK FOOTER
// ./src/components/TopMenu/translate.json
// module id = 969
// module chunks = 0